/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.MeevoMessenger {
    export class LoginValidatorDirective implements angular.IDirective {
        require = '?form';
        restrict = 'A';
        scope = {
            loginValidator: '&'
        };

        link = (scope: any, element: angular.IAugmentedJQuery, attrs: angular.IAttributes, form: any) => {
            scope.$watchGroup([() => form.meevoMessengerUserName.$modelValue, () => form.meevoMessengerToken.$modelValue], (newValues, oldValues) => {
                if (angular.equals(newValues, oldValues) || !form.meevoMessengerUserName.$modelValue || !form.meevoMessengerToken.$modelValue) return;

                form.$submitted = true;
                form.$pending = true;

                scope.loginValidator({ userName: form.meevoMessengerUserName.$modelValue, token: form.meevoMessengerToken.$modelValue })
                    .then(
                        () => form.$setValidity('credentialsVerifyError', true),
                        error => form.$setValidity('credentialsVerifyError', false)
                    ).finally(() => form.$pending = false);
            });
        };

        constructor() { }

        static factory(): angular.IDirectiveFactory {
            let directive = () => {
                return new LoginValidatorDirective();
            };
            directive.$inject = [];

            return directive;
        }
    }

    angular.module("meevo.plugins.meevoMessenger")
        .directive("loginValidator", LoginValidatorDirective.factory());
}
